import ArrowCounterClockWiseIcon from "../../../../assets/svg/arrow-counterclockwise.svg?react";

export function ArrowCounterClockWise() {
  return <ArrowCounterClockWiseIcon />;
}
